import { render, staticRenderFns } from "./OrderPackaging.vue?vue&type=template&id=63567271&scoped=true&"
import script from "./OrderPackaging.vue?vue&type=script&lang=js&"
export * from "./OrderPackaging.vue?vue&type=script&lang=js&"
import style0 from "./OrderPackaging.vue?vue&type=style&index=0&id=63567271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63567271",
  null
  
)

export default component.exports